import _ from "lodash"

export const GetCurrentUser = () => {
    const user = localStorage.getItem("current_user")
    if (user) {
        const user_info = JSON.parse(user)
        const { user_data } = user_info
        return user_data
    } else {
        return null
    }
}
export const GetUserPrivillages = () => {
    const user = localStorage.getItem("current_user")
    try {
        const userInfo = JSON.parse(user)
        const { user_data } = userInfo
        const userType = _.get(user_data, "meta_data.user_type", null)
        return userType
    } catch (error) {
        return null
    }
}
export const isOwner = () => GetUserPrivillages() === "owner"

export const GetUserPlatformId = () => {
    const user = localStorage.getItem("current_user")
    try {
        const userInfo = JSON.parse(user)
        const { user_data } = userInfo
        const userPlatform = _.get(user_data, "meta_data.user_platform", null)
        return userPlatform
    } catch (error) {
        return null
    }
}
export function generateRandomId(length = 10) {
    const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
    const array = new Uint8Array(length)
    crypto.getRandomValues(array)

    return Array.from(array, x => chars[x % chars.length]).join("")
}

export const privilegesList = [
    "Add Member",
    "Edit Member",
    "Delete Member",
    "View Members",
    "Manage Roles",
    "Generate Reports",
    "Upload Content",
    "Delete Content",
    "Create Content"
]
export const userAllowingOperations = () => {
    const userPrivillages = GetUserPrivillages()

    let list = {
        update: false,
        delete: false,
        create: false,
        upload: false,
        generate: false,
        add_member: false,
        edit_member: false,
        delete_member: false
    }

    if (!userPrivillages) {
        return list
    }

    // Admin & Owner have all permissions
    if (userPrivillages === "admin" || userPrivillages === "owner") {
        return {
            update: true,
            delete: true,
            create: true,
            upload: true,
            generate: true,
            add_member: true,
            edit_member: true,
            delete_member: true
        }
    }

    if (Array.isArray(userPrivillages)) {

        userPrivillages.forEach((permission) => {
            switch (permission) {
                case "Add Member":
                    list.add_member = true
                    break

                case "Edit Member":
                    list.edit_member = true
                    break

                case "Delete Member":
                    list.delete_member = true
                    break

                case "Generate Reports":
                    list.generate = true
                    break

                case "Upload Content":
                    list.upload = true
                    break

                case "Delete Content":
                    list.delete = true
                    break

                case "Create Content":
                    list.create = true
                    break

                // If editing content means update permission
                case "Edit Content":
                    list.update = true
                    break

                default:
                    break
            }
        })
    }

    return list
}

export const ExamGradeRemarks = [
    "Outstanding",
    "Excellent",
    "Very Good",
    "Good",
    "Above Average",
    "Average",
    "Needs Improvemen",
    "Below Average",
    "Poor",
    "Fail"
]
export const Gradding = [
    "A+",
    "A",
    "B+",
    "B",
    "C+",
    "C"
]

export const local_url = "http://210.79.129.8"
export const production_url = "http://210.79.129.8"